import { render, staticRenderFns } from "./ListarFormacoesDialog.vue?vue&type=template&id=6d7f71f2"
import script from "./ListarFormacoesDialog.vue?vue&type=script&lang=js"
export * from "./ListarFormacoesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports